<div class="run-preview-skeleton" aria-label="Loading job timeline">
  @for (node of [1, 2]; track node) {
    <div class="skeleton-node">
      <div class="skeleton-node__header">
        <div class="skeleton-line skeleton-line--header"></div>
      </div>
      <div class="skeleton-node__content">
        <div class="skeleton-line"></div>
        <div class="skeleton-line skeleton-line--short"></div>
      </div>
    </div>
    @if (!$last) {
      <div class="skeleton-connector"></div>
    }
  }
</div>
